/* Avisa antes de abandonar una pantalla con trabajo sin enviar (enlaces, atrás/
 * adelante del navegador, navigate()). Va DENTRO de <BrowserRouter>: usa la
 * `history` que el Router publica por contexto, porque `useBlocker` exige un
 * data router y la app no lo es. La lógica vive en lib/navigationGuard.js. */
import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
import { installNavigationGuard, installPopstateGuard } from "../lib/navigationGuard";
import { confirmLeave } from "../lib/unsavedWork";

export default function NavigationGuard() {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  useEffect(() => {
    const confirm = () => confirmLeave("salir");
    // index.js ya instaló el guard de popstate antes de montar el Router (es el
    // único orden que funciona); aquí solo se asegura en entornos sin index.js.
    installPopstateGuard(window, confirm);
    return installNavigationGuard({ navigator, win: window, confirm });
  }, [navigator]);
  return null;
}
